import React from "react";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import SidebarNavItem from "./SidebarNavItem";
import SidebarSubNavItem from "./SidebarSubNavItem";
import styles from "./FloatingSidebar.module.scss";

const FloatingSidebar = ({
  title,
  items,
  activeItemId,
  activeSubItemId,
  onItemSelect,
  collapsed,
  onToggleCollapse,
}) => {
  if (!items || items.length === 0) return null;

  const CollapseIcon = collapsed ? ChevronRightIcon : ChevronLeftIcon;
  const showTitle = Boolean(title) && !collapsed;
  const showHeader = showTitle || Boolean(onToggleCollapse);

  return (
    <Paper
      elevation={0}
      className={`${styles.sidebar} ${collapsed ? styles.sidebarCollapsed : ""}`}
    >
      {showHeader && (
        <div className={styles.sidebarHeader}>
          {showTitle && <h2 className={styles.sidebarTitle}>{title}</h2>}
          {onToggleCollapse && (
            <IconButton
              onClick={onToggleCollapse}
              className={styles.collapseIconButton}
              aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
              <CollapseIcon />
            </IconButton>
          )}
        </div>
      )}

      <List className={styles.navList} disablePadding>
        {items.map((item, index) => {
          if (!item) return null;

          const isLastItem = index === items.length - 1;
          const isParentActive = item.id === activeItemId;
          const hasSubItems =
            Array.isArray(item.subItems) && item.subItems.length > 0;
          const showSubItems = hasSubItems && isParentActive && !collapsed;
          const isParentDirectActive = isParentActive && !hasSubItems;
          const isParentHighlighted =
            isParentDirectActive ||
            (isParentActive && hasSubItems && Boolean(activeSubItemId));

          return (
            <React.Fragment key={item.id}>
              <div
                className={`${styles.navGroup} ${
                  showSubItems ? styles.navGroupExpanded : ""
                }`}
              >
                <SidebarNavItem
                  item={item}
                  isActive={isParentHighlighted}
                  isGroupExpanded={showSubItems && !isParentHighlighted}
                  isCollapsed={collapsed}
                  onSelect={onItemSelect}
                />
                {showSubItems && (
                  <div className={styles.navSubList}>
                    {item.subItems.map((subItem) => (
                      <SidebarSubNavItem
                        key={subItem.id}
                        item={subItem}
                        isActive={subItem.id === activeSubItemId}
                        onSelect={onItemSelect}
                      />
                    ))}
                  </div>
                )}
              </div>
              {!isLastItem && <Divider className={styles.navDivider} />}
            </React.Fragment>
          );
        })}
      </List>
    </Paper>
  );
};

export default FloatingSidebar;
